"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const uniqBy_1 = __importDefault(require("lodash/uniqBy"));
const core_1 = require("@material-ui/core");
const checkboxUnchecked_1 = __importDefault(require("../../../../../svgIcons/checkboxUnchecked"));
const lab_1 = require("@material-ui/lab");
const Children = (props) => {
    const { classes, data, filters, getExperts, getServiceExperts, directoryType, type } = props.props;
    const requestType = directoryType === 'serviceExperts' ? getServiceExperts : getExperts;
    const selected = !!filters[type].find(f => f.id === data.id && f.parent_id === data.parent_id);
    const [checked, onChange] = react_1.default.useState(selected || false);
    const changedFilters = cloneDeep_1.default(Object.assign(Object.assign({}, filters), { offset: 0 }));
    const handleChange = (e) => {
        const check = (!selected && checked) ? false : checked;
        const isChecked = !check;
        if (isChecked) {
            changedFilters[type].push(data);
            changedFilters[type] = uniqBy_1.default([].concat(changedFilters[type]), v => [v.id, v.parent_id].join());
            requestType(changedFilters);
        }
        else {
            const index = changedFilters[type].findIndex(f => f.id === data.id && f.parent_id === data.parent_id);
            if (index > -1) {
                changedFilters[type].splice(index, 1);
                requestType(changedFilters);
            }
        }
        onChange(isChecked);
        e.preventDefault();
    };
    const itemId = `${data.id}_${data.parent_id}`;
    const label = (react_1.default.createElement("div", { className: classes.labelContainer },
        react_1.default.createElement("div", null,
            react_1.default.createElement(core_1.Checkbox, { disableRipple: true, value: data.name, checked: selected, id: itemId, className: classes.checkbox, icon: react_1.default.createElement(checkboxUnchecked_1.default, null), checkedIcon: (selected) ? react_1.default.createElement("span", { className: classes.checkedIcon }) : react_1.default.createElement(checkboxUnchecked_1.default, null) })),
        react_1.default.createElement("div", null,
            react_1.default.createElement("label", { style: { cursor: "pointer" }, htmlFor: data.id, className: classes.childLabelText }, data.name))));
    return (react_1.default.createElement(lab_1.TreeItem, { className: 'child-item', key: itemId, nodeId: itemId, onLabelClick: handleChange, label: label, classes: {
            content: classes.content
        } }));
};
exports.default = Children;
